<div
  [ngClass]="containerClass"
  class="image-container"
  [style.width]="maxWidth | pxToRem"
  [style.height]="maxHeight | pxToRem"
>
  <figure class="image-figure">
    <picture class="image-picture">
      <source *ngFor="let source of sources" [media]="source.media" [srcset]="source.src | assetPath" />
      <img
        *ngIf="src"
        [src]="$any(src) | assetPath"
        [alt]="alt"
        [attr.title]="title || null"
        class="image-fluid"
        (error)="onImageError($event)"
      />
    </picture>
  </figure>
</div>
